export enum LvfVehicleKilometerSource {

  UNKNOWN = 0,
  EXTERNAL_SOFTWARE = 1,
  AUTOMATIC = 2,
  MANUAL = 3
}
